import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FileDialogCPanelComponent } from './customizationPanel';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { MatButtonModule } from '@angular/material/button';
import { TableModule } from 'primeng/table';

export interface FileDialogCustomization {
  fileNameConfiguration: string;
  required: boolean;
}

@Component({
  selector: 'lib-filedialog-edit',
  imports: [
    MatIconModule,
    FileDialogCPanelComponent,
    FormsModule,
    MatButtonModule,
    TableModule,
  ],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-filedialog-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <p-table class="rounded-xl" [value]="[]">
        <ng-template #header>
          <tr>
            <th>Documenti</th>
            <th></th>
            <th class="w-0 items-end">
              <button mat-icon-button>
                <mat-icon svgIcon="heroicons_outline:paper-clip" />
              </button>
            </th>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="3" class="py-4 text-center">
              <div class="text-sm text-gray-500">
                Nessun file caricato. Clicca sulla graffetta o trascina qui un
                file per eseguire l'upload
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  `,
  styleUrls: ['../style.css'],
})
export class FileDialogComponent {
  protected dragDropService = inject(DragDropService);
  protected widgetService = inject(WidgetService<FileDialogCustomization>);
}
